export default __webpack_public_path__ + "static/media/SaraDesktop.54150a2c.png";